import { Injectable } from '@angular/core';
import { initializeApp, FirebaseApp, FirebaseOptions } from 'firebase/app';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FirebaseService {
  private app: FirebaseApp;

  constructor() {
    this.app = initializeApp(environment.firebase as FirebaseOptions);
  }

  getApp(): FirebaseApp {
    return this.app;
  }
}
